import { CountryCode, Customer } from '../pages/types';

export const isCanadianCustomer = (customer: Customer) => {
  return customer.default_country === CountryCode.CA;
};
